<template>
  <div class="fill-height">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    if (this.$route.name === 'app') {
      const { client_uuid, location_uuid } = this.$route.query; // eslint-disable-line camelcase
      this.$router.push({
        name: 'oneTimePassWelcome',
        query: {
          client_uuid, location_uuid,
        },
      });
    }
  },
};
</script>
